/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The phase of a dispute within the dispute lifecycle.
 */
export const DisputePhase = {
  PreDispute: "pre-dispute",
  Inquiry: "inquiry",
  Chargeback: "chargeback",
  Unknown: "unknown",
} as const;
/**
 * The phase of a dispute within the dispute lifecycle.
 */
export type DisputePhase = ClosedEnum<typeof DisputePhase>;

/** @internal */
export const DisputePhase$inboundSchema: z.ZodNativeEnum<typeof DisputePhase> =
  z.nativeEnum(DisputePhase);
/** @internal */
export const DisputePhase$outboundSchema: z.ZodNativeEnum<typeof DisputePhase> =
  DisputePhase$inboundSchema;
